/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessListGrants } from "../funcs/accessListGrants.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListUserGrantsResult } from "../models/components/listusergrantsresult.js";
import {
  ListGrantsRequest,
  ListGrantsSecurity,
} from "../models/operations/listgrants.js";
import { unwrapAsync } from "../types/fp.js";
export type GrantsQueryData = ListUserGrantsResult;

export function prefetchGrants(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListGrantsRequest | undefined,
  security?: ListGrantsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGrantsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGrantsQuery(
  client$: GramCore,
  request?: ListGrantsRequest | undefined,
  security?: ListGrantsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<GrantsQueryData>;
} {
  return {
    queryKey: queryKeyGrants({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
    }),
    queryFn: async function grantsQueryFn(ctx): Promise<GrantsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(accessListGrants(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGrants(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "access", "listGrants", parameters];
}
